import { DialogContentText as MuiDialogContentText } from '@mui/material';
// import { DialogContentTextProps as MuiDialogContentTextProps } from '@mui/material';
export const DialogContentText = MuiDialogContentText;
// export type DialogContentTextProps = MuiDialogContentTextProps;
